import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SimpleHeader from './components/SimpleHeader.tsx';
import SimpleFooter from './components/SimpleFooter.tsx';
import SkipToContent from './components/accessibility/SkipToContent.tsx';
import Home from './pages/Home.tsx';
import Work from './pages/Work.tsx';
import ProjectDetail from './pages/ProjectDetail.tsx';
import Memes from './pages/Memes.tsx';
import MemeDetail from './pages/MemeDetail.tsx';
import Contact from './pages/Contact.tsx';
import './i18n/config.ts';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-background-primary">
        <SkipToContent />
        <SimpleHeader />
        <main id="main-content" className="flex-grow" tabIndex={-1}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Work />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/memes" element={<Memes />} />
            <Route path="/memes/:id" element={<MemeDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <SimpleFooter />
      </div>
    </Router>
  );
}

export default App;
